/**
 * Where the environment's OIDC settings are served from.
 *
 * Under `assets/` because that is what the deployment mounts over: the Helm
 * chart maps the `auth-web-secret` Secret to
 * `/usr/share/nginx/html/assets/auth/oauth-configuration.json`, which is how
 * each environment gets its own client. A file read from anywhere else is the
 * one baked into the image, and that one belongs to dev.
 */
export const AUTH_CONFIGURATION_PATH = '/assets/auth/oauth-configuration.json';
